/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutoApplyCouponUpdate } from '../../models/auto-apply-coupon-update';
import { Empty } from '../../models/empty';

export interface CouponsAutoApplyCouponIdPut$Params {
  'Active-Tenant-Identifier': string;
  couponId: string;
      body: AutoApplyCouponUpdate
}

export function couponsAutoApplyCouponIdPut(http: HttpClient, rootUrl: string, params: CouponsAutoApplyCouponIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
  const rb = new RequestBuilder(rootUrl, couponsAutoApplyCouponIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('couponId', params.couponId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Empty>;
    })
  );
}

couponsAutoApplyCouponIdPut.PATH = '/coupons/auto-apply/{couponId}';
